export class HomeControl {
  constructor(resetView) {
    this.resetView = resetView;
  }

  onAdd(map) {
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'mapboxgl-ctrl-home';
    this.button.title = 'Reset map view';
    this.button.setAttribute('aria-label', 'Reset map view');
    const icon = document.createElement('span');
    icon.className = 'material-icons';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = 'home';
    this.button.appendChild(icon);
    this.handleClick = () => {
      map.stop();
      this.resetView(map);
    };
    this.button.addEventListener('click', this.handleClick);
    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove() {
    this.button.removeEventListener('click', this.handleClick);
    this.container.remove();
  }
}
